// custom cells for the table
import CreationDate from "./Cells/CreationDate";
import Name from "./Cells/Name";
import SecretKey from "./Cells/SecretKey";

type Col = {
	id: string;
	Cell: (transaction: any) => JSX.Element | null;
	label: string;
	align?: "center" | "left";
};

const cols: Col[] = [
	{
		id: "name",
		Cell: Name,
		label: "Nombre",
		align: "left"
	},
	{
		id: "key",
		Cell: SecretKey,
		align: "left",
		label: "Key"
	},
	{
		id: "createdAt",
		Cell: CreationDate,
		align: "left",
		label: "Fecha de creación"
	}
];

export default cols;
